const ROLES_FOR_APP = {
    DASHBOARD_VIEW: "dashboard:view",

    ROLE_LIST: "operator_management:role:view",
    ROLE_CREATE: "operator_management:role:view",
    ROLE_UPDATE: "operator_management:role:view",
    ROLE_DELETE: "operator_management:role:view",

    USER_LIST: "user_management:view",
    USER_CREATE: "user_management:view",
    USER_UPDATE: "user_management:view",
    USER_DELETE: "user_management:view",

    OPERATOR_LIST: "operator_management:operator:view",
    OPERATOR_CREATE: "operator_management:operator:view",
    OPERATOR_UPDATE: "operator_management:operator:view",
    OPERATOR_DELETE: "operator_management:operator:view",

    KEYWORD_TASK_LIST: "keyword:task:view",
    KEYWORD_TASK_CREATE: "keyword:task:view",
    KEYWORD_TASK_UPDATE: "keyword:task:view",
    KEYWORD_TASK_DELETE: "keyword:task:view",

    KEYWORD_BOOST_LIST: "keyword:boosting:view",
    KEYWORD_BOOST_CREATE: "keyword:boosting:view",
    KEYWORD_BOOST_UPDATE: "keyword:boosting:view",
    KEYWORD_BOOST_DELETE: "keyword:boosting:view",

    KEYWORD_REAL_TIME_LIST: "keyword:realtime:view",
    KEYWORD_REAL_TIME_CREATE: "keyword:realtime:view",
    KEYWORD_REAL_TIME_UPDATE: "keyword:realtime:view",
    KEYWORD_REAL_TIME_DELETE: "keyword:realtime:view",

    KEYWORD_GOLDEN_LIST: "keyword:golden:view",
    KEYWORD_GOLDEN_CREATE: "keyword:golden:view",
    KEYWORD_GOLDEN_UPDATE: "keyword:golden:view",
    KEYWORD_GOLDEN_DELETE: "keyword:golden:view",

    KEYWORD_EXCLUDE_LIST: "keyword:exclude:view",
    KEYWORD_EXCLUDE_CREATE: "keyword:exclude:view",
    KEYWORD_EXCLUDE_UPDATE: "keyword:exclude:view",
    KEYWORD_EXCLUDE_DELETE: "keyword:exclude:view",

    KEYWORD_NAVER_LIST: "keyword:naver:view",
    KEYWORD_NAVER_CREATE: "keyword:naver:view",
    KEYWORD_NAVER_UPDATE: "keyword:naver:view",
    KEYWORD_NAVER_DELETE: "keyword:naver:view",

    JOURNALIST_LIST: "sending_email:send:view",
    JOURNALIST_CREATE: "sending_email:send:view",
    JOURNALIST_UPDATE: "sending_email:send:view",
    JOURNALIST_DELETE: "sending_email:send:view",

    GENERAL_NEWS_LIST: "simulator:general:view",
    GENERAL_NEWS_CREATE: "simulator:general:view",
    GENERAL_NEWS_UPDATE: "simulator:general:view",
    GENERAL_NEWS_DELETE: "simulator:general:view",

    GENERATE_NEWS_LIST: "simulator:news:view",
    GENERATE_NEWS_CREATE: "simulator:news:view",
    GENERATE_NEWS_UPDATE: "simulator:news:view",
    GENERATE_NEWS_DELETE: "simulator:news:view",

    GENERATE_CAR_NEWS_LIST: "simulator:car:view",
    GENERATE_CAR_NEWS_CREATE: "simulator:car:view",
    GENERATE_CAR_NEWS_UPDATE: "simulator:car:view",
    GENERATE_CAR_NEWS_DELETE: "simulator:car:view",

    CATEGORY_LIST: "keyword:boosting:view",//
    CATEGORY_CREATE: "keyword:boosting:view",//
    CATEGORY_UPDATE: "keyword:boosting:view",//
    CATEGORY_DELETE: "keyword:boosting:view",//

    MAIL_LIST: "mail_list",//
    MAIL_CREATE: "mail_create",//
    MAIL_UPDATE: "mail_update",//
    MAIL_DELETE: "mail_remove",//
    MAIL_LOG: "sending_email:log:view",
    MAIL_STATISTICS: "sending_email:statistics:view",

    ACTIVITY_LOG_LIST: 'operator_management:activity_log:view',

    AI_NEWS: "ai_news:view",
    GOVERNMENT_NEWS: "ai_news:view", // 
    IMAGE_BASED_NEWS: "ai_news:view",//
    LOGO_BASED_NEWS: "ai_news:view",//
    BOOSTING_NEWS: "boosting_news:view",
    EXTRACT_DAILY_SEARCH_VOLUME: 'boosting_news:view', //

    REAL_TIME_NEWS: 'realtime_news:view',

    BOOSTING_CONTENT_NEWS: 'boosting_content:car:view',

    CAMPAIGN_CAR_LIST: "boosting_content:car:view",
    CAMPAIGN_CAR_CREATE: "boosting_content:car:view",
    CAMPAIGN_CAR_UPDATE: "boosting_content:car:view",
    CAMPAIGN_CAR_DELETE: "boosting_content:car:view",

    DATA_CAR_LIST: "boosting_content:car:view",
    DATA_CAR_CREATE: "boosting_content:car:view",
    DATA_CAR_UPDATE: "boosting_content:car:view",
    DATA_CAR_DELETE: "boosting_content:car:view",

    CAMPAIGN_APP_TECH_LIST: "boosting_content:apptech:view",
    CAMPAIGN_APP_TECH_CREATE: "boosting_content:apptech:view",
    CAMPAIGN_APP_TECH_UPDATE: "boosting_content:apptech:view",
    CAMPAIGN_APP_TECH_DELETE: "boosting_content:apptech:view",

    DATA_APP_TECH_LIST: "boosting_content:apptech:view",
    DATA_APP_TECH_CREATE: "boosting_content:apptech:view",
    DATA_APP_TECH_UPDATE: "boosting_content:apptech:view",
    DATA_APP_TECH_DELETE: "boosting_content:apptech:view",


    CAMPAIGN_GOLD_PRICE_LIST: "boosting_content:gold_price:view",
    CAMPAIGN_GOLD_PRICE_CREATE: "boosting_content:gold_price:view",
    CAMPAIGN_GOLD_PRICE_UPDATE: "boosting_content:gold_price:view",
    CAMPAIGN_GOLD_PRICE_DELETE: "boosting_content:gold_price:view",

    DATA_GOLD_PRICE_LIST: "boosting_content:gold_price:view",
    DATA_GOLD_PRICE_CREATE: "boosting_content:gold_price:view",
    DATA_GOLD_PRICE_UPDATE: "boosting_content:gold_price:view",
    DATA_GOLD_PRICE_DELETE: "boosting_content:gold_price:view",


    CAMPAIGN_VOTE_LIST: "boosting_content:dc_trend:view",
    CAMPAIGN_VOTE_CREATE: "boosting_content:dc_trend:view",
    CAMPAIGN_VOTE_UPDATE: "boosting_content:dc_trend:view",
    CAMPAIGN_VOTE_DELETE: "boosting_content:dc_trend:view",

    DATA_VOTE_LIST: "boosting_content:dc_trend:view",
    DATA_VOTE_CREATE: "boosting_content:dc_trend:view",
    DATA_VOTE_UPDATE: "boosting_content:dc_trend:view",
    DATA_VOTE_DELETE: "boosting_content:dc_trend:view",


    CAMPAIGN_VOTE_KEYWORD_LIST: "boosting_content:dc_trend:view",//
    CAMPAIGN_VOTE_KEYWORD_CREATE: "boosting_content:dc_trend:view",//
    CAMPAIGN_VOTE_KEYWORD_UPDATE: "boosting_content:dc_trend:view",//
    CAMPAIGN_VOTE_KEYWORD_DELETE: "boosting_content:dc_trend:view",//

    DATA_VOTE_KEYWORD_LIST: "boosting_content:dc_trend:view",//
    DATA_VOTE_KEYWORD_CREATE: "boosting_content:dc_trend:view",//
    DATA_VOTE_KEYWORD_UPDATE: "boosting_content:dc_trend:view",//
    DATA_VOTE_KEYWORD_DELETE: "boosting_content:dc_trend:view",//

    NEWS_RECOMPOSITION: "boosting_news:view", // 
    NEWS_TRAVEL: "boosting_news:view", // 
    NEWS_WEATHER: "boosting_news:view", // 
    NEWS_WEATHER_WARNING: "boosting_news:view", // 
    NEWS_STOCK: "boosting_news:view", // 
    NEWS_TOSS_STOCK: "boosting_news:view", // 

    ARTICLE_TRACKING: 'news_monitor:view',

    LOG: 'statistics:daily:view',//
    DAILY_STATISTICS: 'statistics:daily:view',
    HOURLY_STATISTICS: 'statistics:hourly:view',
    KEYWORD_STATISTICS: 'statistics:keyword:view',
    KEYWORD_REAL_TIME_STATISTICS: 'statistics:keyword:view',
    KEYWORD_PUBLISHED_STATISTICS: 'statistics:cumulative:view',
    CATEGORY_STATISTICS: 'statistics:category:view',
    MEDIA_STATISTICS: 'statistics:media:view',
    SURVIVAL_STATISTICS: 'statistics:survival:view',
    APPROVED_ARTICLE_STATISTICS: 'statistics:approved:view',

    CONFIGURATION_AI_NEWS: 'configuration:ai_news:view',
    CONFIGURATION_AI_CUSTOM_NEWS: 'configuration:ai_news:view', // 
    CONFIGURATION_REAL_TIME_KEYWORD_USER: 'configuration:ai_news:view', // 
    CONFIGURATION_POPULAR_KEYWORD_USER: 'configuration:boosting_news:view', // 
    CONFIGURATION_BOOSTING_NEWS: 'configuration:boosting_news:view',
    CONFIGURATION_BOOSTING_NEWS_V2: 'configuration:boosting_news:view',//
    CONFIGURATION_BOOSTING_NEWS_STOCK: 'configuration:boosting_news:view',//
    CONFIGURATION_BOOSTING_NEWS_TOSS_STOCK: 'configuration:boosting_news:view',//
    CONFIGURATION_BOOSTING_NEWS_TRAVEL: 'configuration:boosting_news:view',//
    CONFIGURATION_BOOSTING_NEWS_WEATHER: 'configuration:boosting_news:view',//
    CONFIGURATION_BOOSTING_NEWS_WEATHER_WARNING: 'configuration:boosting_news:view',//
    CONFIGURATION_APP_TECH: 'configuration:boosting_news:view',//
    CONFIGURATION_GOVERNMENT_NEWS: 'configuration:boosting_news:view',//
    CONFIGURATION_REAL_TIME_NEWS: 'configuration:realtime_news:view',
    CONFIGURATION_TASK_KEYWORD: 'configuration:task_keyword:view',

    CONFIGURATION_REAL_KEYWORD: 'configuration:task_keyword:view',

    GOOGLE_IMAGE_LIST: "image_management:google:view",
    GOOGLE_IMAGE_CREATE: "image_management:google:view",
    GOOGLE_IMAGE_UPDATE: "image_management:google:view",
    GOOGLE_IMAGE_DELETE: "image_management:google:view",

    IMAGE_LIBRARY_LIST: "image_management:custom_image:view",
    IMAGE_LIBRARY_CREATE: "image_management:custom_image:view",
    IMAGE_LIBRARY_UPDATE: "image_management:custom_image:view",
    IMAGE_LIBRARY_DELETE: "image_management:custom_image:view",

    IMAGE_PUBLIC_LIST: "image_management:custom_image:view", //
    IMAGE_PUBLIC_CREATE: "image_management:custom_image:view",//
    IMAGE_PUBLIC_UPDATE: "image_management:custom_image:view",//
    IMAGE_PUBLIC_DELETE: "image_management:custom_image:view",//


    NEWSHUB_MEDIA: "media_management:media:view",
    NEWSHUB_CAMPAIGN: "media_management:campaign:view",
    NEWSHUB_NEWS: "media_management:news:view",


    LAB: "lab:view",

};

const isHavePermissionRole = (keyRoles: string | string[], permissions: { id: string | number, name: string }[] = []): boolean => {
    try {
        const roles = typeof keyRoles === 'string' ? [keyRoles] : keyRoles;
        return permissions?.some(item => roles?.includes(item.name));
    } catch (error) {
        console.error(error);
        return false;
    }
    // return true;
};

export { ROLES_FOR_APP, isHavePermissionRole };